var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotViewed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5418 10.5418C10.3421 10.7562 10.1012 10.9281 9.83357 11.0474C9.56593 11.1666 9.27702 11.2308 8.98407 11.2359C8.69111 11.2411 8.40012 11.1872 8.12844 11.0775C7.85677 10.9677 7.60998 10.8044 7.4028 10.5972C7.19562 10.39 7.03229 10.1432 6.92255 9.87157C6.81282 9.5999 6.75893 9.30891 6.7641 9.01595C6.76927 8.723 6.83339 8.43409 6.95264 8.16645C7.07189 7.89882 7.24382 7.65794 7.45818 7.4582M13.32 13.32C12.0768 14.2677 10.563 14.7926 9 14.8182C3.90909 14.8182 1 9.00002 1 9.00002C1.90465 7.31412 3.15937 5.84119 4.68 4.68002L13.32 13.32ZM7.47273 3.35638C7.97333 3.2392 8.48586 3.18063 9 3.18184C14.0909 3.18184 17 9.00002 17 9.00002C16.5585 9.82591 16.032 10.6035 15.4291 11.32L7.47273 3.35638Z",
    stroke: "#2B8FF5",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 1L17 17",
    stroke: "#2B8FF5",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotViewed);
export default __webpack_public_path__ + "static/media/not-viewed.6eddc17d35b411491c6d2ef3bc044f9a.svg";
export { ForwardRef as ReactComponent };